import React from "react";
import { post } from "../../utils/request";
import api from "./api";
import { Icon } from "antd-mobile";
import { href } from "../../utils/util";
import "./index.less";
import headImg from "../images/head.png";
import md5 from "blueimp-md5";
import sha256 from "crypto-js/sha256";
import { Button, Modal, Toast, Badge, Picker, List } from "antd-mobile";

class customerServiceCenter extends React.Component {
    constructor(props) {
        super(...props);
        this.state = {
            urlOps: {},
            list: [],
            detail: {},
        };
    }
    componentWillMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
        }

        this.setState(
            {
                urlOps: ops,
            },
            () => {
                this.getQueryQuestioncsList();
                const { app_stoken, access_token } = this.state.urlOps;
                if (
                    // (access_token && access_token !== 'null' && access_token !== '(null)' && access_token !== 'undefined') ||
                    app_stoken &&
                    app_stoken !== "null" &&
                    app_stoken !== "(null)" &&
                    app_stoken !== "undefined"
                ) {
                    this.getSelectLatestCompactDetail();
                    this.getQueryCustomerInfo();
                } else {
                    localStorage.setItem("userInfo", "");
                }
            }
        );
    }

    getQueryQuestioncsList() {
        post({
            url: api.queryQuestioncsList,
            data: {},
        }).then(
            (res) => {
                // console.log('常见问题列表查询', res)
                // Toast.info(res.msg,1);
                if (res.result === "success" && res.data) {
                    this.setState({
                        list: res.data,
                    });
                } else {
                }
            },
            (res) => {}
        );
    }

    getSelectLatestCompactDetail() {
        var { app_stoken, access_token } = this.state.urlOps;
        let url = "";
        let ops = "";
        // if(access_token && access_token !== 'null' && access_token !== '(null)' && access_token !== 'undefined'){
        //     url = api.selectLatestCompactDetail + '?app_stoken=' + access_token;
        //     // ops = 'access_token=' + access_token;
        // }
        if (
            app_stoken &&
            app_stoken !== "null" &&
            app_stoken !== "(null)" &&
            app_stoken !== "undefined"
        ) {
            url = api.selectLatestCompactDetail + "?app_stoken=" + app_stoken;
            // ops = 'app_stoken=' + app_stoken;
        }
        post({
            url: url,
            data: {},
        }).then(
            (res) => {
                // console.log('客户信息查询', res)
                // Toast.info(res.msg,1);
                if (res.result === "success" && res.data) {
                    this.setState({
                        detail: res.data,
                    });
                } else {
                }
            },
            (res) => {
                // console.log('客户信息查询失败', res)
            }
        );
    }

    // 查询客户信息
    getQueryCustomerInfo = () => {
        var { app_stoken, access_token } = this.state.urlOps;
        if (
            app_stoken &&
            app_stoken !== "null" &&
            app_stoken !== "(null)" &&
            app_stoken !== "undefined"
        ) {
            post({
                url: api.queryCustomerInfo + "?app_stoken=" + app_stoken,
                data: {},
            }).then((res) => {
                if (res.result === "success") {
                    localStorage.setItem("userInfo", JSON.stringify(res.data));
                }
            });
        }
    };

    onlineContact() {
        let userInfo = localStorage.getItem("userInfo")
            ? JSON.parse(localStorage.getItem("userInfo"))
            : {};
        // //构建客服访问URL
        // let url = 'https://zjlshl.s4.udesk.cn/im_client/?web_plugin_id=32358';
        const userTypes = {
            1: "大B客户",
            2: "中小B客户",
            3: "二网客户",
            4: "C端",
        };
        // if(userInfo){
        //   userInfo = JSON.parse(userInfo);
        //   if(!userInfo){
        //     Toast.info('当前登录信息缺失!',1);
        //     return;
        //   }
        //   url = url + '&c_cf_认证名称='+userInfo.realname
        //   url = url + '&c_cf_昵称='+userInfo.customername
        //   url = url + '&c_cf_绑定手机号='+userInfo.phonenumber
        //   url = url + '&c_cf_通知手机号='+userInfo.noticephonenumber
        //   url = url + '&c_cf_账号名='+userInfo.loginaccount
        //   url = url + '&c_cf_城市='+userInfo.city
        //   url = url + '&c_cf_客户类型='+userTypes[userInfo.tiertype]
        // }else{
        //     window.location.href = 'https://zjlshl.s4.udesk.cn/im_client/?web_plugin_id=32358'
        //     return;
        // }
        // //下面为鉴权参数
        // const web_token = md5('HIC-' + userInfo.defaultTenant.partyId)
        // const nonce = Math.random()
        // const timestamp = new Date().getTime()
        // const im_user_key = '0614a37d77ba39005bfeba926ef3cfcd'
        // const signature = sha256(`nonce=${nonce}&timestamp=${timestamp}&web_token=${web_token}&${im_user_key}`).toString().toUpperCase()
        // //这里也需要拼接
        // url = url + '&nonce='+nonce
        // url = url + '&timestamp='+timestamp
        // url = url + '&web_token='+web_token
        // //新开网页跳转在线客服
        // url = url + '&signature='+signature
        // url = url + '&encryption_algorithm=SHA256'
        // window.location.href = url;

        let baseUrl =
            "https://farizon-chat.geely.com/farizon/onlineAgent/channel?instanceId=MTIzODA%3D";
        let params = {};
        if (userInfo) {
            params = {
                nickName: userInfo.customername, // 客户管理中客户的【昵称】
                certifiedName: userInfo.realname, // 客户管理中客户的【认证名称】
                boundPhoneNumber: userInfo.phonenumber, // 客户管理中客户的【绑定手机号】
                notificationPhoneNumber: userInfo.noticephonenumber, // 客户管理中客户的【通知手机号】
                accountName: userInfo.loginaccount, // 客户管理中客户的【账号名】
                organization: userInfo.organizationName, // 客户管理中客户的【组织】
                customerType: userTypes[userInfo.tiertype], // 客户管理中客户的【客户类型】
            };
        }

        // 将params对象转换为URL查询参数
        const urlParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined && value !== null && value !== "") {
                urlParams.append(key, value);
            }
        }

        // 拼接URL和查询参数
        const queryString = urlParams.toString();
        let url = baseUrl + (queryString ? `&${queryString}` : "");
        console.log(url);
        window.location.href = url;
    }

    render() {
        const { list, detail } = this.state;
        return (
            <div className="customerServiceCenterBox">
                {detail.managerUserName ? (
                    <div className="adviser">
                        <div>
                            <img
                                src={
                                    detail.managerHeadPortrait
                                        ? detail.managerHeadPortrait
                                        : headImg
                                }
                            />
                            <h2>{detail.managerUserName}</h2>
                            <p>租车、用车、故障、出险等问题都能联系我～</p>
                        </div>
                        <div className="tel">
                            <a href={`tel:${detail.managerPhoneNumber}`}>
                                <span>联系专属客户经理</span>
                            </a>
                        </div>
                    </div>
                ) : (
                    ""
                )}

                <div className="hotline">
                    <a href="tel:4008262266">
                        <div className="imgBox">
                            <img src={headImg} />
                        </div>
                        <div className="hotlineContent">
                            <div>
                                全国统一客服热线:<span>400-826-2266</span>
                            </div>
                            <p>服务时间：周一至周日 07:30-21:00</p>
                        </div>
                        <div className="hotlineBtn">
                            <Icon
                                type="right"
                                color="#DDDDDD"
                            />
                        </div>
                    </a>
                </div>

                <div className="problem">
                    <h2>猜你想问</h2>
                    {list.length > 0 ? (
                        <ul>
                            {list.map((item, index) => {
                                return (
                                    <li
                                        key={item.contentId}
                                        onClick={() => {
                                            href(
                                                `/customerServiceCenterDetail?id=${item.contentId}`
                                            );
                                        }}
                                    >
                                        {item.contentTitle}
                                        <Icon
                                            type="right"
                                            color="#DDDDDD"
                                        />
                                    </li>
                                );
                            })}
                        </ul>
                    ) : (
                        <div className="listNone">问题收集中～</div>
                    )}
                </div>
                <div className="onLine">
                    <div
                        onClick={() => {
                            this.onlineContact();
                        }}
                    >
                        在线客服
                    </div>
                </div>
            </div>
        );
    }
}

export default customerServiceCenter;



// WEBPACK FOOTER //
// ./src/customerServiceCenter/index/index.js